import React from 'react'
import Link from 'next/link'
import { useRouter } from 'next/router'

import Head from 'components/Head'
import SiteLayout from 'components/SiteLayout'
import LoginForm from 'components/LoginForm'
import THEME from 'utils/theme'
import { usePageView, useIntercom } from 'hooks'

const SigninPage = () => {
  usePageView()
  useIntercom()
  const router = useRouter()

  const { query } = router
  const { redirectHref = '/' } = query

  const showPurchaseCopy = redirectHref.startsWith('/events/[id]')
  return (
    <>
      <SiteLayout background={THEME.COLORS.BACKGROUND_GRAY} minimalHeader>
        <Head title='Sign In | Rough N’ Rowdy' noIndexNoFollow />
        <div className='container' data-testid='SigninPage'>
          {showPurchaseCopy ? (
            <>
              <h1 className='title'>Access Rough N' Rowdy in just three steps.</h1>
              <p className='subtitle'>
                <span className='steps'>Step 1 of 3</span>
                Provide your account information below.
              </p>
            </>
          ) : (
            <>
              <h1 className='title'>Login</h1>
              <p className='subtitle'>
                Enter your email address and password. If you have a Barstool Sports account, you may use it to access
                Rough N' Rowdy.
              </p>
            </>
          )}
          <LoginForm />
          <div className='signin__footer'>
            <p>Don't have an account?</p>
            <Link href='/account/signup' className='btn btn--secondary'>
              Join Now
            </Link>
          </div>
        </div>
      </SiteLayout>
      <style jsx>{`
        .container {
          max-width: 345px;
          padding: 3rem 0;
          margin: 0 auto;
        }
        .signin__footer {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          margin-top: 1rem;
        }
        .signin__footer .btn {
          width: 100%;
        }
        .title {
          margin-top: 0;
          margin-bottom: 0;
          padding-bottom: 25px;
          color: ${THEME.COLORS.TEXTCOLOR};
          font-family: ${THEME.FONTS.HELVETICA};
          font-size: 32px;
          font-weight: 300;
          letter-spacing: 0;
          line-height: 40px;
        }
        .subtitle {
          margin: 0;
          margin-bottom: 28px;
          font-size: 14px;
          letter-spacing: 0;
          line-height: 18px;
        }
        .steps {
          display: block;
          font-family: ${THEME.FONTS.BEBAS};
          font-size: 16px;
          font-weight: normal;
          letter-spacing: 0.89px;
          line-height: 19px;
        }
      `}</style>
    </>
  )
}

export default SigninPage
